<template>
  <div>
    <div v-if="!section[keyValue]" class="custom-img-btn">
      <input
        ref="uploader"
        class="d-none"
        type="file"
        name="photo"
        accept="image/*"
        @change="onFileChanged"
      />            
      <Button 
        label="Upload de imagem" 
        color="bt_gray_bg"
        textColor="darkBlue"
        textSize="0.80rem"
        icon="fa-solid fa-upload"
        @click="handleUpload"
      />
    </div>

    <div v-else class="custom-img">
      <div class="thumb" :style="`background-image: url(${section[keyValue]})`"></div>
      <div class="url">{{getImageName(section[keyValue])}}</div>
      <DeleteButton @click="handleDeleteImage"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Button from '../ui/Button.vue'
import DeleteButton from '../ui/DeleteButton.vue'

export default {
  name: 'UploadImage',
  components: {Button, DeleteButton},
  props: {
    value: {type: Object}, // object needs to have property "logo"
    keyValue: {type: String, default: 'logo'}
  },

  computed: {
    ...mapGetters(['infos']),
    section: {
      get () { return this.value },
      set (v) { 
        this.$emit('input', v)
      }      
    }
  },

  methods: {
    handleUpload () {
      this.$refs.uploader.click()
    },

    handleDeleteImage () {
      this.section = {...this.section, [this.keyValue]: ''}
    },

    async onFileChanged(event) {
      const { files } = event.target
      const formData = new FormData();
      formData.append("media", files[0]);
      formData.append("hotsiteId", this.infos["organizer-id"]);

      const uploadedImg = await this.$store.dispatch("setImage", {
        formData: formData,
        token: this.$route.params.token,
      });

      if (uploadedImg.url) this.section = {...this.section, [this.keyValue]: uploadedImg.url}
    }, 

    getImageName (url) {
      return url.split('/').pop() || ''
    }       
  }
}
</script>

<style scoped>
.custom-img {
  display: flex;
  align-items: center;
  gap: 8px
}

.custom-img-btn button {
  width: 100% !important;
  transition: all 0.3s
}

.custom-img-btn button:hover {
  background-color: #CBCBCE !important;
}

.custom-img .thumb {
  min-width: 40px;
  min-height: 40px;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid #EDEDF1;
}

.custom-img .url {
  flex: 1;
  overflow: hidden;
  direction: rtl; 
  font-size: 0.9rem
}

.custom-img .delete {
  display: flex;
  justify-content: end;
  min-width: 50px;
}
</style>